export const iconFontAwesomeHumanitarianPersonShelter = (
	<i className="fa-solid fa-person-shelter"></i>
);
